module.exports = __webpack_public_path__ + "static/data-d684fa1724b8c0d811d79c14fba71a0f.svg";